export default "__VITE_ASSET__CjKJqEVl__"